import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/fp/get';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import { LANGUAGE, LANGUAGES } from 'config/types/prop';
import { buildCTALink } from 'utils/url';
import { getEdition } from 'selectors/getEdition';
import createGetTranslation from 'selectors/i18n';
import withStyles from 'isomorphic-style-loader/withStyles';
import I18n from 'components/i18n';
import breakpoints from 'config/css/breakpoints';
import FlagLanguageItem from '../flagLanguageItem';
import LanguagePickerCondensed from '../condensed';
import { numberOfVisibleFlags } from '../numberOfVisibleFlags';
import styles from './masthead.css';

class MastheadLanguagePicker extends Component {
  constructor(props) {
    super(props);
    this.masthead = null;
    this.intersectionObserver = null;

    this.state = {
      isSticky: false,
    };
  }

  componentDidMount() {
    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => this.setState({ isSticky: 1 > entry.intersectionRatio }),
      {
        rootMargin: window.matchMedia(breakpoints['--lgMin']).matches ? '148px 0px 0px 0px' : '-1px 0px 0px 0px',
        threshold: 1,
      },
    );

    this.intersectionObserver.observe(this.masthead);
  }

  componentWillUnmount() {
    this.intersectionObserver.unobserve(this.masthead);
  }

  render() {
    const { links, currentEdition, getTranslation } = this.props;
    const { isSticky } = this.state;
    const showingLanguages = links.slice(0, numberOfVisibleFlags);
    const goLink = buildCTALink(currentEdition);
    const seeMoreText = getTranslation('masthead-more', 'More...');

    return (
      <div
        className={styles.masthead}
        ref={(masthead) => { this.masthead = masthead; }}
      >
        <LanguagePickerCondensed
          currentEdition={currentEdition}
          getTranslation={getTranslation}
          isSticky={isSticky}
          languages={links}
        />
        <div className={styles.wrapper}>
          <div className={styles.heading}>
            <I18n
              field="masthead-title"
              defaultText="Ready to learn?"
            />
            <div className={styles.subtitle}>
              <I18n
                field="masthead-subtitle"
                defaultText=""
              />
            </div>
          </div>
          <ul className={styles.list}>
            {showingLanguages.map((item) => (
              <li className={styles.item} key={`${item.text}${item.url}`}>
                <FlagLanguageItem
                  {...item}
                  styles={styles}
                  isCircle
                />
              </li>
            ))}
            <li className={styles.item}>
              <FlagLanguageItem
                flag="plus"
                url={goLink}
                styles={styles}
                text={seeMoreText}
                isCircle
                hasPlus
              />
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const currentEdition = getEdition(state);
  const languagesByEdition = get('languagePicker', state);
  const getTranslation = createGetTranslation(state);

  return {
    ...languagesByEdition[currentEdition],
    currentEdition,
    getTranslation,
  };
};

MastheadLanguagePicker.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape(LANGUAGE),
  ),
  currentEdition: LANGUAGES.isRequired,
  getTranslation: PropTypes.func.isRequired,
};

MastheadLanguagePicker.defaultProps = {
  links: [],
};

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(withRedux(MastheadLanguagePicker));
